// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 加载错误报告工具
import error_emitter from './utils/error-emitter';
error_emitter.install();
// 加载 Vue 及相关插件
import Vue from 'vue';
import {sync} from 'vuex-router-sync';
// 加载 Layer 弹窗组件
import 'layer-src';
// 加载路由和状态管理
import router from './router';
import store from './store';
// 加载样式
import './styles.scss';
import 'layer-src/src/theme/default/layer.css';
// 加载自定义插件
import vueWaves from './plugins/vue-waves';
Vue.use(vueWaves);
// 注册粘性定位指令
import Sticky from 'vue-sticky-directive/vue-sticky-directive'
Vue.use(Sticky);

/*
import ContextMenu from '@gahing/vcontextmenu'
import '@gahing/vcontextmenu/lib/vcontextmenu.css'
Vue.use(ContextMenu)*/

// 加载全局过滤器
import * as filters from './filters';
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
// 加载布局组件
import Layout from './components/layout/layout';
// 同步路由和状态
sync(store, router);
// 配置 Vue
Vue.config.productionTip = false;
// 开发环境配置
if (process.env.NODE_ENV !== 'production') {
  Vue.config.devtools = true;
  Vue.config.performance = true
} else {
  Vue.config.errorHandler = function (err, vm, info) {
    error_emitter.report({
      source: 'vue',
      err,
      vm,
      info
    });
  };
}
// 创建 Vue 实例
new Vue({
  el: '#app',
  router,
  store,
  template: '<Layout/>',
  components: {Layout}
});



// WEBPACK FOOTER //
// ./src/main.js